import { motion } from 'framer-motion';
import { Button, Screen } from '@/components/ui';
import { useTranslations } from '@/shared/i18n';

export function WelcomeScreen({ onStart }: { onStart: () => void }): React.ReactNode {
  const dictionary = useTranslations();

  return (
    <Screen className="items-center justify-center px-8 text-center">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 220, damping: 20 }}
        className="mb-8 flex size-28 items-center justify-center rounded-3xl bg-accent/15 text-6xl"
      >
        🎭
      </motion.div>

      <motion.h1
        initial={{ y: 16, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.1 }}
        className="text-[28px] font-semibold tracking-tight text-text"
      >
        {dictionary.onboarding.welcomeTitle}
      </motion.h1>

      <motion.p
        initial={{ y: 16, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.18 }}
        className="mt-3 text-[15px] leading-relaxed text-text-muted"
      >
        {dictionary.onboarding.welcomeSubtitle}
      </motion.p>

      <motion.div
        initial={{ y: 24, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.28 }}
        className="mt-auto w-full pb-4 pt-12"
      >
        <Button onClick={onStart}>{dictionary.onboarding.welcomeAction}</Button>
      </motion.div>
    </Screen>
  );
}
